import { CXF } from '@goodgamestudios/cxf-runtime'
import logBase from '../utils/logger'
import { CxfEvents, GOOGLE_ADBLOCK_TAG, IGS_ENTRY_TAB_ID, IGS_AD_BLOCK_SOURCE_ID } from '../constants'
import { trackPopupShown, trackPopupShopLinkClicked } from '../tracking'

const log = logBase.extend('AD-BLOCK-DETECTION')
let isFirstTimeShowPopup = true

const initAdBlockHandler = (cxf: CXF) => {
  // Loads the google ad blocker scripts and define the control message condition
  if (window.googlefc) {
    return
  }

  log('Google Funding Choices API and ad blocker loading...')

  controlledMessagingFunction()

  addGoogleAdBlockScriptsToDOM()

  addPurchaseButtonListener(cxf)
}

const controlledMessagingFunction = () => {
  // Make sure that the properties exist on the window.
  window.googlefc = window.googlefc || {}
  window.googlefc.ccpa = window.googlefc.ccpa || {}
  window.googlefc.callbackQueue = window.googlefc.callbackQueue || []

  // To guarantee functionality, this must go before the FC tag on the page.
  window.googlefc.controlledMessagingFunction = (message: Record<string, any>) => {
    if (isFirstTimeShowPopup) {
      trackPopupShown()
      isFirstTimeShowPopup = false
    }

    message.proceed(true)
  }
}

const addGoogleAdBlockScriptsToDOM = () => {
  const fundingChoicesApiScript = document.createElement('script')
  const adBlockingRecoveryScript = document.createElement('script')
  const adBlockerErrorHandlingScript = document.createElement('script')

  fundingChoicesApiScript.async = true
  fundingChoicesApiScript.src = GOOGLE_ADBLOCK_TAG

  // @ts-expect-error 'import.meta' is handled by babel
  adBlockingRecoveryScript.src = new URL('ad-blocking-recovery-script.min.js', import.meta.url).toString()
  // @ts-expect-error 'import.meta' is handled by babel
  adBlockerErrorHandlingScript.src = new URL('error-protection-message-script.min.js', import.meta.url).toString()

  document.head.append(fundingChoicesApiScript, adBlockingRecoveryScript, adBlockerErrorHandlingScript)
}

const addPurchaseButtonListener = (cxf: CXF) => {
  history.pushState(null, '', ' ')

  window.addEventListener(
    'hashchange',
    (event) => {
      if (event.newURL.includes('#store') && !event.oldURL.includes('#store')) {
        cxf.emit(CxfEvents.OpenIGS, {
          page: IGS_ENTRY_TAB_ID,
          sourceId: IGS_AD_BLOCK_SOURCE_ID,
        })
        adBlockModal.hide()
        trackPopupShopLinkClicked()
      }

      cxf.once(CxfEvents.CloseIGS, () => {
        adBlockModal.show()
        history.pushState(null, '', ' ')
      })
    },
    false
  )
}

class AdBlockModal {
  elementIdentifier: string
  status: string
  constructor(elementIdentifier: string) {
    this.status = ''
    this.elementIdentifier = elementIdentifier
  }

  get element() {
    let [modalElement] = document.querySelectorAll(this.elementIdentifier)
    if (!modalElement) {
      log('Adblock consent modal not found, using fallback')
      modalElement = document.createElement('div')
    }

    return modalElement
  }

  show() {
    trackPopupShown()
    this.element.removeAttribute('style')
    this.status = 'visible'
  }

  hide() {
    this.element.setAttribute('style', 'display: none!important')
    this.status = 'hidden'
  }

  remove() {
    this.element.remove()
    this.status = 'removed'
  }

  isShown() {
    return this.status === 'visible'
  }

  isHidden() {
    return this.status === 'hidden'
  }

  isRemoved() {
    return this.status === 'removed'
  }
}

const adBlockModal = new AdBlockModal('.fc-ab-root')

export { initAdBlockHandler, adBlockModal }
